import type { ReactNode } from 'react'
import styles from './CompleteRegistration.module.css'

export interface CompleteRegistrationProps {
  children: ReactNode
}

export function CompleteRegistration({ children }: CompleteRegistrationProps) {
  return (
    <div className={styles.root}>
      <div className={styles.form}>{children}</div>
      <div className={styles.illustration}></div>
    </div>
  )
}

export interface CompleteRegistrationErrorProps {
  children: ReactNode
}

export function CompleteRegistrationError({
  children,
}: CompleteRegistrationErrorProps) {
  return <div className={styles.error}>{children}</div>
}
